import { Button } from "@/components/ui/button";
import { useLocation } from "react-router-dom";
import { generateOAuthState } from "@/lib/auth/oauth-state";
import signinBackgroundImage from "@/assets/image/signin_background_image.png";
import logoWithText from "@/assets/image/logo_with_text.png";

export default function LoginPage() {
  const location = useLocation();
  const from = (location.state as { from?: string })?.from || "/subscriptions";

  const handleGoogleLogin = () => {
    const params = new URLSearchParams({
      client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
      response_type: "code",
      redirect_uri: `${import.meta.env.VITE_APP_URL}/callback/google`,
      scope: "openid email profile",
      access_type: "offline",
      prompt: "consent",
      state: generateOAuthState(from),
    });

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    window.location.href = authUrl;
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden">
      <img
        src={signinBackgroundImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
        style={{ pointerEvents: "none" }}
      />

      <img
        src={logoWithText}
        alt="Novela"
        className="absolute z-10"
        style={{ left: 30, top: 17, width: 104, height: 30 }}
      />

      <div className="relative z-10 w-full max-w-md space-y-8 rounded-2xl bg-white p-10 shadow-md">
        <div className="flex flex-col items-center gap-2">
          <p className="text-2xl font-semibold text-gray-600">관리자 로그인</p>
        </div>

        <div className="mt-8">
          <Button onClick={handleGoogleLogin} className="w-full" size="lg" variant="outline">
            <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            구글로 계속하기
          </Button>
        </div>

        <p className="mt-4 text-center text-xs text-gray-500">관리자 권한이 있는 계정만 접근 가능합니다</p>
      </div>
    </div>
  );
}
